$(document).on('change', '#lobbyist_registration_id', (e) => {
    $(".registration-period").empty()
    //@ts-ignore
    let registrationPeriod = e.currentTarget.selectedOptions[0].dataset.registrationPeriod;
    let registrationPeriodDisplay = $(`<h6>The event must be held within this Registration Period:</h6>
                                                             <p>${registrationPeriod}</p>`);
   $(".registration-period").append(registrationPeriodDisplay)
});